export const formatCoordinate = (coordinate) => {
  return [coordinate?.longitude || 0, coordinate?.latitude || 0];
};
